module.exports = __webpack_public_path__ + "static/media/NOP.88c3a899.png";